import { ISortBy } from '../../Models/sortby.model';
import SortBy from '../forms/sort-by';
import ModalCustom from '../UI/modal';

type Props = {
  show: boolean;
  handleClose: () => void;
  dataSort: { value: ISortBy; label: string }[];
  setSortBy?: (sortBy: ISortBy) => void;
};

const SortedByModal = ({ show, handleClose, dataSort }: Props) => {
  return (
    <ModalCustom
      dialogClassName='small-dialog-modal'
      show={show}
      onHide={handleClose}
      title='Sort By'
      paddingHeader='20px 20px'
      headerClassName='border-0 modal-header-p-20'
      paddingBody='24px 20px 20px'
    >
      <SortBy
        sortByArray={dataSort}
        handleClose={handleClose}
      />
    </ModalCustom>
  );
};
export default SortedByModal;
